import { ButtonGroup, Button } from '@flos/react-ui';
import React from 'react';
import { useHippoText } from '../hooks/useHippoText';

const WizardPagetemplate = ({
    children,
    hideNext = false,
    hidePrevious = false,
    disableNext = false,
    disablePrevious = false,
    isNextLoading = false,
    isPreviousLoading = false,
    onNext = () => {},
    onPrevious = () => {},
    continueButtonText = ''
}: {
    hideNext?: boolean;
    hidePrevious?: boolean;
    disableNext?: boolean;
    disablePrevious?: boolean;
    isNextLoading?: boolean;
    isPreviousLoading?: boolean;
    onNext?: () => void;
    onPrevious?: () => void;
    continueButtonText?: string;
    children: React.ReactNode;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const hippoTexts = {
        continue: getHippoText('DSS-COMMON-CONTINUE'),
        back: getHippoText('DSS-COMMON-BACK')
    };

    return (
        <>
            <div className="u-spacing-inset-l--stretch-max">{children}</div>
            <ButtonGroup>
                {!hideNext && (
                    <Button
                        id="gw-wizard-next"
                        onClick={onNext}
                        disabled={disableNext}
                        isLoading={isNextLoading}
                    >
                        {continueButtonText || hippoTexts.continue}
                    </Button>
                )}
                {!hidePrevious && (
                    <Button
                        id="gw-wizard-previous"
                        onClick={onPrevious}
                        theme="ghost"
                        className={disablePrevious ? '' : 'u-color-primary-2-base'}
                        disabled={disablePrevious}
                        isLoading={isPreviousLoading}
                    >
                        {hippoTexts.back}
                    </Button>
                )}
            </ButtonGroup>
        </>
    );
};

export default WizardPagetemplate;
